import { createContext } from 'react';

export const ErrorContext = createContext(null);
export const ShowSuccessToast = createContext(null);
export const EnterpriseId = createContext(null);
